import React from 'react';
import classNames from 'classnames';
import { CircleButton } from '@capcenter/shared';

import HouseMissingImage from '../../Shared/img/single-family.svg';
import './ImageCarousel.scss';

interface ImageCarouselProps {
	className?: string,
	photos: Array<{
		order: number,
		url: string
	}>,
	addressText: string;
}

const ImageCarousel = (props: ImageCarouselProps) => {
	const [prevActive, setPrevActive] = React.useState(true);
	const [nextActive, setNextActive] = React.useState(true);
	const [activeImageId, setActiveImageId] = React.useState(1);
	let photoCount = 0;

	if (props.photos !== undefined) {
		photoCount = props.photos.length;
	}

	React.useEffect(() => {
		setPrevActive(activeImageId > 1);
		setNextActive(activeImageId !== (photoCount));
	}, [activeImageId, props.photos, photoCount]);

	const mainImage = () => {
		if (photoCount !== 0 && activeImageId <= photoCount) {
			return props.photos.find((p: any) => p.order === activeImageId - 1)?.url;
		} else {
			// blank imageURL
			return HouseMissingImage;
		}
	};

	function handlePrevClick(e: Event) {
		e.preventDefault();
		if (prevActive) {
			setActiveImageId(activeImageId - 1);
		} else void (0);  // do nothing if on first image
	}

	function handleNextClick(e: Event) {
		e.preventDefault();
		if (nextActive) {
			setActiveImageId(activeImageId + 1);
		} else void (0);  // do nothing if on first image
	}

	return (
		photoCount ? <div id="image-carousel" className={classNames(props.className && props.className, 'image-carousel')}>
			<CircleButton
				icon="fas fa-chevron-left image-carousel-nav-btn__icon"
				variant="flat"
				color="white"
				className={classNames(!prevActive && 'disabled', 'image-carousel__nav-btn image-carousel__nav-btn--prev')}
				onClick={(e: Event) => handlePrevClick(e)}
				tabIndex={0}
			/>
			<div className="image-carousel__main-image-wrapper">
				<img src={mainImage()} alt={props.addressText} className="image-carousel__main-image" />

				<div className="image-carousel__photo-count">
					{`${activeImageId} / ${photoCount}`}
				</div>

			</div>
			<CircleButton
				icon="fas fa-chevron-right image-carousel-nav-btn__icon"
				variant="flat"
				color="white"
				className={classNames(!nextActive && 'disabled', 'image-carousel__nav-btn image-carousel__nav-btn--next')}
				onClick={(e: Event) => handleNextClick(e)}
				tabIndex={0}
			/>
		</div> :

			<div id="image-carousel" className={classNames(props.className && props.className, 'image-carousel')}>
				<div className="image-carousel__main-image-wrapper">
					<img src={HouseMissingImage} alt={props.addressText} className="image-carousel__main-image" />
					<div className="image-carousel__photo-count">
            0 / 0
					</div>
				</div>
			</div>

	);
};

export default ImageCarousel;
